import "../../styles/all.css";
import "./backblog.css";
import { useTranslation } from "react-i18next";

function Backblog() {
  const { t } = useTranslation();

  return (
    <>
      <div className="backblog" data-aos = "fade-left">
        <div className="continerr"> 
          <h2>{t("titleblog")}</h2>
          <h3>{t("descriptionblog")}</h3>
        </div>
      </div>
    </>
  );
}

export default Backblog;